import React, {Component} from 'react'
import {connect} from 'react-redux'
import RequiredMultiSelect from '../../../common/form/elements/required-multi-select'
import MultiSelect from '../../../common/form/multi-select'
import {Form, actions,} from 'react-redux-form'
import {Row, Col, FormGroup} from 'react-bootstrap'
import RequiredInput from '../../../common/form/elements/required-input'
import RequiredAutoRedemptionDate from './required-autoredemption-date';
import AutoRedemptionDate from './autoredemption-date';
import ArrowButton from '../../../common/button-arrow'
import {getStaffRewardSettings, getVouchers, saveStaffRewardSettings} from '../../../../actions/staff'

class StaffRewardSettingsForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: ''
    };
  }

  componentWillMount() {
    this.props.dispatch(getStaffRewardSettings());
    this.props.dispatch(getVouchers());
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.savedVouchers
    })
  }

  onSubmit = (payLoad) => {
    this.props.dispatch(actions.submitFields('deep.admin_staff_reward.settings', saveStaffRewardSettings(payLoad)));
  };

  addAutoRedemptionDate = () => {
    this.props.dispatch(actions.push('deep.admin_staff_reward.settings.autoredemption_dates', ''));
  };

  onDeleteAutoRedemptionDate = (index) => {
    this.props.dispatch(actions.remove('deep.admin_staff_reward.settings.autoredemption_dates', index));
  };

  handleChange = (value) => {
    // this.setState({
    //   values: value
    // });
  };

  render() {
    return (
      <Form model="deep.admin_staff_reward.settings" onSubmit={this.onSubmit}>
        <Row>
          <Col lg={12}>
            <RequiredInput label="Points per €"
                           placeholder="e.g. 100"
                           model=".point_per_euro"
                           controlId="ppe"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredInput label="Reward Markup %"
                           placeholder="e.g. 10"
                           model=".reward_markup"
                           controlId="markupPercent"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="vouchers-col">
            <RequiredMultiSelect data={this.props.allVouchers.map(voucher => {return {id: voucher.id, name: voucher.attributes.name}})}
                                 value={this.props.savedVouchers}
                                 label="Available Vouchers"
                                 labelAttr="name"
                                 valueAttr="id"
                                 controlId="availableVouchers"
                                 model='deep.admin_staff_reward.settings.available_vouchers'/>
          </Col>
        </Row>

        <RequiredAutoRedemptionDate />
        {
          this.props.autoRedemptionDates.map((date, index) => {
            return <AutoRedemptionDate key={index}
                                       index={index}
                                       onDelete={this.onDeleteAutoRedemptionDate}/>
          })
        }

        <Row>
          <Col lg={12}>
            <FormGroup>
              <ArrowButton submit={false}
                           arrow={false}
                           onClick={this.addAutoRedemptionDate}
                           color="grey">Add date</ArrowButton>
            </FormGroup>
          </Col>
        </Row>

        <div>
          <Row>
            <Col lg={12}>
              <RequiredInput
                label="Threshold start date"
                placeholder="e.g. 01/01 (dd/mm)"
                pattern="\d\d/\d\d"
                model=".threshold_start_date"
                controlId="startdate"
              />
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <RequiredInput
                label="Threshold duration (months)"
                placeholder="e.g. 12"
                model=".threshold_duration"
                controlId="duration"
              />
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <RequiredInput
                label="Max number of vouchers"
                placeholder="e.g. 2"
                model=".max_vouchers_for_duration"
                controlId="maxvouchers"
              />
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <RequiredInput
                label="Max voucher value"
                placeholder="e.g. 750"
                model=".max_voucher_value"
                controlId="vouchercalue"
              />
            </Col>
          </Row>
        </div>
        <Row>
          <Col lg={12}>
            <ArrowButton color="grey"
                         className="pull-right"
                         disabled={!this.props.formValid}>Save</ArrowButton>
          </Col>
        </Row>
      </Form>


    )
  }
}

const mapStateToProps = (state) => {
  return {
    formValid: state.deep.forms.admin_staff_reward.settings.$form.valid,
    autoRedemptionDates: state.deep.admin_staff_reward.settings.autoredemption_dates,
    savedVouchers: state.deep.admin_staff_reward.settings.available_vouchers,
    allVouchers: state.staff.redemptions.vouchers,
    features: state.features
  };
};

export default connect(mapStateToProps)(StaffRewardSettingsForm);


// WEBPACK FOOTER //
// ./src/components/admin/staff-reward/settings/staff-reward-settings-form.jsx